

import CommonApi from './../commonApi';
const сontractVehiclePlan = new CommonApi(
  'contractVehiclePlan',
  'план НТС'
);
export default сontractVehiclePlan;
